import { render, staticRenderFns } from "./CardFormatter.vue?vue&type=template&id=2bcfbe54&scoped=true"
import script from "./CardFormatter.vue?vue&type=script&lang=ts"
export * from "./CardFormatter.vue?vue&type=script&lang=ts"
import style0 from "./CardFormatter.vue?vue&type=style&index=0&id=2bcfbe54&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcfbe54",
  null
  
)

export default component.exports